"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoApplyCoupon = exports.updateCart_bff = exports.addItemsAndPromosToCart_bff = exports.addItemToCart_bff = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var interfaces_1 = require("../../common/interfaces");
var index_1 = require("../../../Config/index");
var common_1 = require("../../common");
var transformClientAnnotationToBffInput_1 = require("../../common/transforms/transformClientAnnotationToBffInput");
var transformClientBillingAddressToBffInput_1 = require("../../common/transforms/transformClientBillingAddressToBffInput");
var newRelic_1 = tslib_1.__importDefault(require("../../newRelic"));
var version = '2.32.0';
function addItemToCart_bff(cartId, addItems, hostAnnotations, payment) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var promotions, couponResponse, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promotions = undefined;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, autoApplyCoupon(addItems[0].catalogItemId)];
                case 2:
                    couponResponse = _a.sent();
                    if (couponResponse.success) {
                        promotions = [
                            {
                                code: couponResponse.code,
                            },
                        ];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    //if the call to CDA fails, continue to add item.
                    newRelic_1.default.logError({
                        errorMessage: 'CDA auto-apply coupon failed.',
                        component: 'CSDK',
                        componentVersion: version,
                        originalError: JSON.stringify(e_1),
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, addItemsAndPromosToCart_bff(cartId, addItems, hostAnnotations, promotions, payment)];
            }
        });
    });
}
exports.addItemToCart_bff = addItemToCart_bff;
function addItemsAndPromosToCart_bff(cartId, addItems, hostAnnotations, promotions, payment) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var bffItems, bffVariables;
        return tslib_1.__generator(this, function (_a) {
            bffItems = getAddItemsBffRequest(addItems);
            bffVariables = {
                input: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ cartItems: bffItems }, (payment && {
                    paymentMethods: [
                        {
                            id: payment.cardId,
                        },
                    ],
                })), ((payment === null || payment === void 0 ? void 0 : payment.billingAddress) && {
                    billingAddress: (0, transformClientBillingAddressToBffInput_1.transformClientBillingAddressToBffCartInput)(payment.billingAddress),
                })), (hostAnnotations && {
                    annotations: (0, transformClientAnnotationToBffInput_1.transformClientAnnotationToBffInput)(hostAnnotations),
                })), (promotions && { promotions: promotions })),
            };
            return [2 /*return*/, (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.CREATE_CART, bffVariables, common_1.cartCheckoutGraphRequestToCheggResponse)];
        });
    });
}
exports.addItemsAndPromosToCart_bff = addItemsAndPromosToCart_bff;
function updateCart_bff(cartId, items, payment, hostAnnotations) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var itemsToReplace, bffUpdateCartInput;
        return tslib_1.__generator(this, function (_a) {
            itemsToReplace = getItemsToReplace(items);
            bffUpdateCartInput = {
                input: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ cartId: cartId }, (itemsToReplace &&
                    itemsToReplace.length > 0 && {
                    cartItems: getAddItemsBffRequest(itemsToReplace),
                })), (payment && {
                    paymentMethods: [
                        {
                            id: payment.cardId,
                        },
                    ],
                })), ((payment === null || payment === void 0 ? void 0 : payment.billingAddress) && {
                    billingAddress: (0, transformClientBillingAddressToBffInput_1.transformClientBillingAddressToBffCartInput)(payment.billingAddress),
                })), (hostAnnotations && {
                    annotations: (0, transformClientAnnotationToBffInput_1.transformClientAnnotationToBffInput)(hostAnnotations),
                })),
            };
            return [2 /*return*/, (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.UPDATE_CART, bffUpdateCartInput, common_1.cartCheckoutGraphRequestToCheggResponse)];
        });
    });
}
exports.updateCart_bff = updateCart_bff;
function getItemsToReplace(items) {
    return items && items.filter(function (item) { return item.replace; });
}
function getAddItemsBffRequest(items) {
    return items.map(function (item) {
        var catalogItemId = item.catalogItemId, pricingId = item.pricingId, catalogItemSource = item.catalogItemSource, annotation = item.annotation;
        return tslib_1.__assign({ catalogItemId: catalogItemId, pricingLogId: pricingId, catalogItemSource: catalogItemSource }, (annotation && {
            annotations: (0, transformClientAnnotationToBffInput_1.transformClientAnnotationToBffInput)(tslib_1.__assign({}, annotation)),
        }));
    });
}
function autoApplyCoupon(itemId) {
    var requestParams = {
        itemId: itemId,
        dataRequested: 'autoApplyCouponByItemId',
    };
    return BaseApi_1.default.doPostRequestToChegg(index_1.commerceDataAggregatorUrl, requestParams).then(function (resp) {
        var autoApplyCoupon = resp.data.autoApplyCoupon;
        return {
            success: !(autoApplyCoupon === null || autoApplyCoupon === void 0 ? void 0 : autoApplyCoupon.error) && !!(autoApplyCoupon === null || autoApplyCoupon === void 0 ? void 0 : autoApplyCoupon.data.couponCode),
            code: autoApplyCoupon === null || autoApplyCoupon === void 0 ? void 0 : autoApplyCoupon.data.couponCode,
        };
    });
}
exports.autoApplyCoupon = autoApplyCoupon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/cartAPI/bff/index.js
// module id = 3384
// module chunks = 11